import React, { FC, useCallback } from 'react'
import styles from 'styles/components/card.module.scss'
import { FlexRow } from 'components/Flex'
import { StaffType } from 'types/staff'
import { useRoleState } from 'hooks/auth'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getUid } from 'reducks/auth/selectors'
import { LightTag, GreyTag } from 'components/Tag'
import { Spacer } from 'components/Utility'
import { openStaffModal } from 'reducks/modal/operations'

type Props = {
  staff: StaffType
}

const MemberCardRow: FC<Props> = (props) => {
  const { staff } = props
  const dispatch = useDispatch()
  const uid = useSelector((state: State) => getUid(state))
  // SSモードであれば生産店舗のroleを取得
  const roleState = useRoleState(staff)
  const openModal = useCallback(() => dispatch(openStaffModal(staff)), [dispatch, staff])

  return (
    <div className={styles.member__row}>
      <FlexRow justifyContent={'between'}>
        <span className={styles.member__row__label}>{staff.email}</span>
        <Spacer size={8} axis={'horizontal'} />
        <FlexRow justifyContent={'start'}>
          {roleState === '管理者' && <LightTag color={'blue'} label={roleState} />}
          {roleState === 'ビューワー' && <LightTag color={'green'} label={roleState} />}
          {roleState === '招待中' && <GreyTag tagName={roleState} />}
          {roleState === '招待期限切れ' && <GreyTag tagName={roleState} />}
          {roleState === '権限なし' && <GreyTag tagName={roleState} />}
          {/* 操作中のユーザーでなければ */}
          <Spacer size={12} axis={'horizontal'} />
          {staff.uid !== uid ? (
            <button className={styles.member__button} onClick={openModal}>
              編集
            </button>
          ) : (
            <Spacer size={36} axis={'horizontal'} />
          )}
        </FlexRow>
      </FlexRow>
    </div>
  )
}

export default MemberCardRow
